// extracted by mini-css-extract-plugin
export default {"wrapper":"x5-z","firstToReview":"y5-z","productCards":"z5-z","productCard":"A5-z","stars":"B5-z","hidden":"C5-z"};